import {combineReducers} from 'redux'
import {productReducer} from './product';
import {testimonialReducer} from './testimonial';
import {contactReducer} from './contact';


export const reducers = combineReducers ({
    allProducts: productReducer,
    allTestimonials: testimonialReducer,
    allContacts: contactReducer
})
